import { Route } from 'react-router-dom';
import { ErrorLayout } from 'components';


let ErrorRoute = (props: any) => {
    return (
        <ErrorLayout>
            <Route {...props} />
        </ErrorLayout>
    )
}

export default ErrorRoute;